import wsClient from "../core/wsClient";
import { buildAuthMessage } from "../utils/buildAuthMessage";

interface AuthParams {
	user_id?: string;
	session_id?: string;
	campaign_context?: {
		customer_id: string;
		account_name: string;
	};
}

const authService = {
	requestAuth(params?: AuthParams) {
		wsClient.sendMessage({ ...buildAuthMessage(), ...params });
	},
};

export default authService;
